
import { supabase } from "@/integrations/supabase/client";
import type { Tables } from '@/integrations/supabase/types';
import type { DocumentInput } from './documentTypes';

export const createDocument = async (
  documentData: DocumentInput, 
  file: File
): Promise<Tables<"documents">> => {
  try {
    // Extract file type and size
    const fileType = file.type;
    const fileSize = file.size;
    
    // Create the document in the database
    const { data, error } = await supabase
      .from('documents')
      .insert({
        title: documentData.title,
        description: documentData.description,
        organization_id: documentData.organization_id,
        contact_id: documentData.contact_id,
        opportunity_id: documentData.opportunity_id,
        is_template: documentData.is_template,
        file_path: `documents/${file.name}`, // Mock file path for now
        file_type: fileType,
        file_size: fileSize,
        uploaded_by: (await supabase.auth.getUser()).data.user?.id
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateDocument = async (
  id: string, 
  data: Partial<DocumentInput>, 
  file?: File
): Promise<Tables<"documents">> => {
  try {
    const updateData: Record<string, any> = { ...data };
    
    if (file) {
      updateData.file_type = file.type;
      updateData.file_size = file.size;
      updateData.file_path = `documents/${file.name}`; // Mock file path
    }
    
    const { data: updatedDoc, error } = await supabase
      .from('documents')
      .update(updateData)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return updatedDoc;
  } catch (error) {
    throw error;
  }
};
